import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import AdminLayout from '../../../components/feature/AdminLayout';
import { NotificationCenter } from './NotificationCenter';
import { AgentStatusDot } from './AgentStatus';
import type { AINotification } from '../types/contracts';

const SUBNAV = [
  { path: '/intelligence', label: 'مركز القيادة', end: true },
  { path: '/intelligence/conversations', label: 'المحادثات' },
  { path: '/intelligence/leads', label: 'العملاء المحتملون' },
  { path: '/intelligence/follow-ups', label: 'المتابعات' },
  { path: '/intelligence/customers', label: 'العملاء' },
  { path: '/intelligence/demo-accounts', label: 'الحسابات التجريبية' },
  { path: '/intelligence/subscriptions', label: 'الاشتراكات' },
  { path: '/intelligence/support', label: 'الدعم' },
  { path: '/intelligence/knowledge', label: 'قاعدة المعرفة' },
  { path: '/intelligence/team', label: 'الفريق / الوكلاء' },
  { path: '/intelligence/settings', label: 'الإعدادات' },
];

export function IntelligenceShell({
  children,
  notifications = [],
  onSearch,
  searchValue,
}: {
  children: ReactNode;
  notifications?: AINotification[];
  onSearch?: (q: string) => void;
  searchValue?: string;
}) {
  return (
    <AdminLayout>
      <div className="mb-5 flex flex-col gap-3">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <div>
            <h1 className="text-xl font-black text-gray-900">ذكاء DressnMore</h1>
            <p className="text-sm text-gray-500">المبيعات الذكية ونجاح العملاء</p>
          </div>
          <div className="flex items-center gap-2">
            {onSearch && (
              <div className="relative">
                <i className="ri-search-line absolute start-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                <input
                  value={searchValue ?? ''}
                  onChange={(e) => onSearch(e.target.value)}
                  placeholder="ابحث عن عميل، نشاط، هاتف، محادثة، عميل محتمل…"
                  className="w-64 max-w-full rounded-xl border border-gray-200 bg-white ps-9 pe-3 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-teal-500/30"
                />
              </div>
            )}
            <AgentStatusDot />
            <NotificationCenter notifications={notifications} />
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto pb-1 -mx-1 px-1">
          {SUBNAV.map((s) => (
            <NavLink
              key={s.path}
              to={s.path}
              end={s.end}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${
                  isActive ? 'bg-gray-900 text-white' : 'text-gray-500 hover:bg-gray-100'
                }`
              }
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
      </div>
      {children}
    </AdminLayout>
  );
}
